import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { CommonService } from "../../../services/common.service";
import * as XLSX from "xlsx";
import { Observable } from "rxjs";
import { MatDialog, MatDialogConfig, MatDialogRef, } from "@angular/material/dialog";
import { LabelConfig } from "../interface/label-config.interface";
import { ConfigFileControllerConfirm } from "../interface/common.interface";
import { saveAs } from "file-saver";

@Component({
  selector: "file-controller",
  templateUrl: "./file-controller.component.html",
})
export class FileControllerComponent implements OnInit, OnChanges {
  @ViewChild("inputFile") inputFile: ElementRef;
  @ViewChild("confirmDialog") templateRef: TemplateRef<any>;
  @Input() labelConfig: LabelConfig;
  @Input() replaceValue: ConfigFileControllerConfirm;
  @Input() hasError: boolean;
  @Input() tempObservable: Observable<any>;

  @Output() getDataEvent = new EventEmitter<any>();
  @Output() confirm = new EventEmitter<any>();

  data_import: any;
  isExcelFile: boolean;

  dialogRef: MatDialogRef<any, any>;
  filename: string = "default-name";

  constructor(private common: CommonService, protected dialog: MatDialog) { }

  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges): void {
    if ("replaceValue" in changes && !changes.replaceValue.isFirstChange()) {
      this.openConfirmDialog();
    }
  }
  onChange(evt) {
    // this.openConfirmDialog();
    this.data_import = [];
    let header;
    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0]?.name.match(/(.xls|.xlsx)/);
    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.data_import = XLSX.utils.sheet_to_json(ws);
      };

      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.filename = target.files[0]?.name;
        this.getDataEvent.emit({
          data: this.data_import,
          name: target.files[0]?.name,
        });
        this.inputFile.nativeElement.value = "";
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }
  openConfirmDialog(config: MatDialogConfig = { width: "350px" }): void {
    if (this.hasError) {
      this.labelConfig = {
        content: this.common.trans("uploadHasErrorMessage", {
          0: this.filename,
          1: this.replaceValue?.dongLoi,
          2: this.replaceValue?.typeLoi,
        }),
        header: this.common.trans("uploadDataError"),
        accept: this.common.trans("downloadFileError"),
      };
    } else {
      this.labelConfig = {
        header: this.common.trans("uploadData"),
        content: this.common.trans("uploadValidMessage", { 0: this.filename }),
        accept: this.common.trans("acceptUpload"),
      };
    }
    this.dialogRef = this.dialog.open(this.templateRef, config);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log("Yes clicked");
      }
    });
  }
  onConfirm(typeConfirm: boolean = false) {
    this.dialogRef.close();
    if (typeConfirm) {
      this.confirm.emit();
    }
  }
  downloadTemplate() {
    if (this.tempObservable) {
      this.tempObservable.subscribe((res: any) => {
        if (!res.error) {
          saveAs(new File([res], res.type));
        }
      });
    }
  }
}
